import { FC, Suspense, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  amlbotAPI,
  B2BFormCompleteRequest,
  B2BFormTokenRequest,
  B2BFormTokenResponse,
} from '@/api';
import { useApiCall } from '@/hooks';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';
import { Helmet } from 'react-helmet';
import B2BForm from './B2BForm';

import styles from './B2BRequest.module.sass';

interface B2BRequestProps {}

const B2BRequest: FC<B2BRequestProps> = () => {
  const [loaded, setLoaded] = useState(false);
  const [user, setUser] = useState<string | number | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const [getTokenData, loading, error] = useApiCall(async () => {
    const queryToken = searchParams.get('token') || '';
    setToken(() => queryToken);
    const payload: B2BFormTokenRequest = {
      token: queryToken,
    };

    const response: B2BFormTokenResponse =
      await amlbotAPI.fetchB2BTokenData(payload);

    if (response.success) {
      setLoaded(() => true);
      setUser(() => response.data.user);
    }
  });

  const [formSubmitted] = useApiCall(async () => {
    const payload: B2BFormCompleteRequest = {
      token: token || '',
      user: user || '',
    };

    await amlbotAPI.completeB2BForm(payload);
  });

  useEffect(() => {
    getTokenData();
  }, []);

  return (
    <HubspotProvider>
      {!loaded && <Suspense />}
      <Helmet>
        <title>AMLBot - B2B Form</title>
        <meta name="description" content="Submit B2B form" />
      </Helmet>
      {loaded && (
        <div className={styles.wrapper}>
          <div className={styles.inner}>
            {!user && 'Record not found'}
            {!!user && (
              <B2BForm formSubmitted={formSubmitted} userId={user} isTG />
            )}
          </div>
        </div>
      )}
    </HubspotProvider>
  );
};

export default B2BRequest;
